<template>
  <section class="py-4">
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <div class="text-center">
            <h3 class="text-h4 font-weight-light mb-3">
              Incredible Perks
            </h3>
            <h4 class="text-body-1 mb-6">
              We reward your achievement with extra perks.
            </h4>
          </div>
        </v-col>
        <v-col cols="12" sm="4" lg="3">
          <h3 class="font-weight-bold text-h6">
            Grand Master
          </h3>
          <v-divider class="my-4" />
          <p>
            <span class="text-body-2">
              <v-icon small class="mr-2 w-25">
                fal fa-store-alt
              </v-icon>
              Print on venue guarantee
            </span>
          </p>
        </v-col>
        <v-col cols="12" sm="4" lg="3">
          <h3 class="font-weight-bold text-h6">
            Artist
          </h3>
          <v-divider class="my-4" />
          <p>
            <span class="text-body-2">
              <v-icon small class="mr-2 w-25">
                fal fa-gavel
              </v-icon>
              Access to Curator's tool
            </span>
          </p>
          <p>
            <span class="text-body-2">
              <v-icon small class="mr-2 w-25">
                fal fa-blog
              </v-icon>
              Blog post interview
            </span>
          </p>
        </v-col>
        <v-col cols="12" sm="4" lg="3">
          <h3 class="font-weight-bold text-h6">
            Legend
          </h3>
          <v-divider class="my-4" />
          <p>
            <span class="text-body-2">
              <v-icon small class="mr-2 w-25">
                fal fa-star
              </v-icon>
              Can vote for Elite gallery
            </span>
          </p>
          <p>
            <span class="text-body-2">
              <v-icon small class="mr-2 w-25">
                fal fa-gift
              </v-icon>
              One free print
            </span>
          </p>
          <p>
            <span class="text-body-2">
              <v-icon small class="mr-2 w-25">
                fab fa-slack
              </v-icon>
              Dedicated Slack channel to stay in direct touch with Editors
            </span>
          </p>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'ReputationPerks'
}
</script>
